import { render, staticRenderFns } from "./ModalEventHistory.vue?vue&type=template&id=0ffef1e5&scoped=true&"
import script from "./ModalEventHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalEventHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffef1e5",
  null
  
)

export default component.exports